import React from 'react';
import capitalize from 'lodash/capitalize';
import getCategoryPath from './getCategoryPath';
import { translateCategoryPath } from './categories';
import LinkAndAnchor from '../components/LinkAndAnchor';

const getCategoryBreadcrumb = (category, hasLocalNews, intl, locale) => {
  const mainCategoryWithPage = locale === 'en-US'
    ? category.path
      .match(/^(executive|education)/)?.[0]
    : null;

  return mainCategoryWithPage ? (
    <LinkAndAnchor
      route={mainCategoryWithPage}
    >
      {capitalize(mainCategoryWithPage)}
    </LinkAndAnchor>
  ) : category.path.includes('/') && (
    <LinkAndAnchor
      route="category"
      params={{
        categoryPath: translateCategoryPath(
          category.path.replace(/\/.+/, ''),
        ),
      }}
    >
      {getCategoryPath(category, hasLocalNews, intl)}
    </LinkAndAnchor>
  );
};

export default getCategoryBreadcrumb;
